import { render, staticRenderFns } from "./UserLimited.vue?vue&type=template&id=a36cb3c4&scoped=true"
import script from "./UserLimited.vue?vue&type=script&lang=js"
export * from "./UserLimited.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36cb3c4",
  null
  
)

export default component.exports